module.exports = __webpack_public_path__ + "img/commander26.png";